import React, { Component } from 'react';
import './PDF.css';
import { Document, Page } from 'react-pdf';
import ArrowLeft from '../../../Resources/Images/angle-left-white.svg';
import ArrowRight from '../../../Resources/Images/angle-right-white.svg';
import Download from '../../../Resources/Images/download-white.svg';
import Spinner from "../../Elements/Spinner/Spinner";
import ShareButton from "../../../Resources/Images/share-alt-solid.svg";

const spinner = <Spinner />

class PDF extends Component {
    constructor(props) {
        super(props);
        this.state = {
            numPages:null,
            pageNumber:1
        };
        this.nextPage = this.nextPage.bind(this);
        this.prevPage = this.prevPage.bind(this);
    }

    onDocumentLoad = ({ numPages }) => {
        this.setState({ numPages });
    }

    nextPage() {
        var c = this.state.pageNumber;
        if(c < this.state.numPages) {
            this.setState({
                pageNumber: (c + 1)
            });
        }
    }

    prevPage() {
        var c = this.state.pageNumber;
        if(c > 1) {
            this.setState({
                pageNumber: (c - 1),
                numPages: this.state.numPages
            });
        }
    }

    render() {
        const { pageNumber, numPages } = this.state;
        var prev = <button type="button" disabled="disabled" className="btn-previous no-select" title="Zurück" onClick={this.prevPage}><img src={ArrowLeft} alt="<--" /></button>;
        if(this.state.pageNumber > 1) {
            prev = <button type="button" className="btn-previous no-select" title="Vorherige Seite" onClick={this.prevPage}><img src={ArrowLeft} alt="<--" /></button>;
        }

        var next = <button type="button" disabled="disabled" className="btn-next no-select" onClick={this.nextPage}><img src={ArrowRight} alt="-->" /></button>;
        if(this.state.pageNumber < this.state.numPages) {
            next = <button type="button" className="btn-next" title="Nächste Seite" onClick={this.nextPage}><img src={ArrowRight} alt="-->" /></button>;
        }

        var share = <a className="share-button no-select" href={"gonative://share/sharePage?url="+encodeURI(this.props.file)}><img height={30} src={ShareButton} alt="Teilen" /></a>
        var download = <a href={this.props.file} className="download-button no-select" target="_blank" data-ajax="false"><img src={Download} alt="Download" height="30" /></a>

        return (
            <div className="pdf-viewer">
                <div className="pdf-viewer--navigation">
                    {prev} {download} {share} {next}
                </div>
                <Document
                    file={this.props.file}
                    onLoadSuccess={this.onDocumentLoad}
                    loading={spinner}
                    >
                    <Page pageNumber={pageNumber} />
                </Document>
                <p>Seite {pageNumber} von {numPages}</p>
            </div>
        );
    }
}

export default PDF;


// WEBPACK FOOTER //
// ./src/Components/Detailview/PDF/PDF.js